export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9998.71b79919.jpg";